import { createWebHistory, createRouter, RouterView } from "vue-router";
import useAuth from '@/providers/auth';

const routes = [
    {
        path: '/',
        name: 'Index',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/mis_recibos',
        name: 'Recibos',
        component: () => import('@/views/MisRecibos.vue')
    },
    {
        path: '/sistema',
        name: 'Sistema',
        component: RouterView,
        meta: {
            auth: true
        },
        children: [
            {
                path: 'inicio',
                component: () => import('@/views/sistema/Resumen.vue'),
                alias: '/sistema',
                name: 'Resumen'
            },
            {
                path: 'editar-cuenta',
                component: () => import('@/views/sistema/Perfil.vue'),
                name: 'Perfil'
            },
            {
                path: 'empleados',
                name: 'Empleados',
                redirect: '/sistema/empleados/lista',
                children: [
                    {
                        path: 'lista',
                        component: () => import('@/views/sistema/empleados/Empleados.vue')
                    },
                    {
                        path: 'nuevo',
                        component: () => import('@/views/sistema/empleados/Nuevo.vue')
                    },
                    {
                        path: 'editar/:id_empleado',
                        component: () => import('@/views/sistema/empleados/Editar.vue')
                    },
                ],
            },
            {
                path: 'servicios',
                name: 'Servicios',
                meta: {
                    roles: ['superadmin', 'administrador', 'solo vista']
                },
                redirect: '/sistema/servicios/lista',
                children: [
                    {
                        path: 'lista',
                        component: () => import('@/views/sistema/servicios/Servicios.vue')
                    },
                    {
                        path: 'nuevo',
                        component: () => import('@/views/sistema/servicios/Nuevo.vue')
                    },
                    {
                        path: 'editar/:id_servicio',
                        component: () => import('@/views/sistema/servicios/Editar.vue')
                    },
                ]
            },
            {
                path: 'usuarios',
                name: 'Usuarios',
                meta: {
                    roles: ['superadmin', 'administrador']
                },
                redirect: '/sistema/usuarios/lista',
                children: [
                    {
                        path: 'lista',
                        component: () => import('@/views/sistema/usuarios/Usuarios.vue')
                    },
                    {
                        path: 'nuevo',
                        component: () => import('@/views/sistema/usuarios/Nuevo.vue')
                    },
                    {
                        path: 'editar/:id_user',
                        component: () => import('@/views/sistema/usuarios/Editar.vue')
                    },
                ]
            },
            {
                path: 'recorridos',
                name: 'Recorridos',
                meta: {
                    roles: ['superadmin', 'administrador', 'solo vista']
                },
                redirect: '/sistema/recorridos/lista',
                children: [
                    {
                        path: 'lista',
                        component: () => import('@/views/sistema/recorridos/recorridos/Recorridos.vue')
                    },
                    {
                        path: 'nuevo',
                        component: () => import('@/views/sistema/recorridos/recorridos/Nuevo.vue')
                    },
                    {
                        path: 'editar/:id_recorrido',
                        component: () => import('@/views/sistema/recorridos/recorridos/Editar.vue')
                    },
                ]
            },
            {
                path: 'puntos',
                name: 'Puntos',
                meta: {
                    roles: ['superadmin', 'administrador', 'solo vista']
                },
                redirect: '/sistema/puntos/lista',
                children: [
                    {
                        path: 'lista',
                        component: () => import('@/views/sistema/recorridos/puntos/Puntos.vue')
                    },
                    {
                        path: 'nuevo',
                        component: () => import('@/views/sistema/recorridos/puntos/Nuevo.vue')
                    },
                    {
                        path: 'editar/:id_punto',
                        component: () => import('@/views/sistema/recorridos/puntos/Editar.vue')
                    },
                ]
            },
            {
                path: 'historial',
                name: 'Historial',
                meta: {
                    roles: ['superadmin', 'administrador', 'solo vista']
                },
                redirect: '/sistema/historial/lista',
                children: [
                    {
                        path: 'lista',
                        component: () => import('@/views/sistema/recorridos/historial/Historial.vue')
                    },
                ]
            },
            {
                path: 'configuracion',
                component: () => import('@/views/sistema/Configuracion.vue'),
                name: 'Configuracion'
            }
        ]
    },
    {
        path: "/:catchAll(.*)",
        component: () => import('@/views/P404.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

const { user, token } = useAuth();

router.beforeEach((to, from, next) => {
    if (to.meta.auth && (!user?.value || token.value === undefined)) {
        next({ name: 'Login', replace: true });
    } else if (to.name === 'Login' && user?.value) {
        next({ name: 'Resumen', replace: true });
    } else {
        if (to.meta.roles) {
            if ((to.meta.roles as Array<string>).includes(user?.value.role)) {
                next();
            } else {
                next('/404');
            }
        } else {
            next();
        }
    }
});

export default router;
